export enum DistributionStatus {
  NOT_STARTED = 'notStarted',
  FINISHED = 'finished',
  UNAVAILABLE = 'unavailable',
}